import { render, staticRenderFns } from "./Preanestecia.vue?vue&type=template&id=231d7b83"
import script from "./Preanestecia.vue?vue&type=script&lang=js"
export * from "./Preanestecia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports